import useCatalog from '../hooks/useCatalog';
import { gardenItems } from '../lib/catalog';
import { WP_KINDS } from '../lib/track';
import { MODE_TRACKS } from '../lib/trackModes';

// legend in garden / agri / forestry: irrigation lines & points from the garden catalog, tracks and forest points
export default function GardenLegend({ t }) {
  const { items } = useCatalog();
  const own = gardenItems(items);
  return (
    <>
      <b data-testid="legend-garden-lines">{t.legGdLines}</b>
      {own.filter((x) => x.kind === 'pipe').map((x) => <div key={x.id} className="lg-row" data-testid={`legend-gd-${x.id}`}><i className="lg-line" style={{ background: x.color }} />{x.name}</div>)}
      <b data-testid="legend-garden-points">{t.legGdPoints}</b>
      {own.filter((x) => x.kind !== 'pipe').map((x) => <div key={x.id} className="lg-row" data-testid={`legend-gd-${x.id}`}><i className="lg-dot lg-sym" style={{ background: x.color }}>{x.sym}</i>{x.name}</div>)}
      <b>{t.legTours}</b>
      {Object.entries(MODE_TRACKS.garden || {}).map(([k, p]) => <div key={k} className="lg-row"><i className="lg-line" style={{ background: p.color }} />{p.icon} {t['trkP_' + k]}</div>)}
      {['woodPile', 'tree', 'damage', 'note'].map((k) => <div key={k} className="lg-row" data-testid={`legend-wp-${k}`}><i className="lg-dot" style={{ background: WP_KINDS[k].color }} />{WP_KINDS[k].icon} {t['wpK_' + k]}</div>)}
    </>
  );
}
